<template>
  <div>
    <div @click="showModal">
      <card :modifier-classes="['card--v', 'card--skeleton']">
        <template v-slot:card-image>
          <prismic-image :field="image"></prismic-image>
        </template>
        <template v-slot:card-content>
          <h3>{{ title }}</h3>
          <!--<p class="lead-text">{{ text }}</p>-->
        </template>
        <template v-slot:card-action>
          <a class="btn btn-primary btn--large" @click="showModal">{{ KriensTourismus.languageKeys['read-more'] }}</a>
        </template>
      </card>
    </div>
    <modal height="auto"
           :scrollable="true"
           :name="'sight-modal-' + title"
           :adaptive="true"
    >
      <div class="modal-content">
        <h2>{{ title }}</h2>
        <p class="lead-text">{{ text }}</p>
        <br v-if="meta" />
        <p v-if="meta" class="lead-text color-black" v-html="meta"></p>
        <br /><br />
        <a v-if="link.url" 
           class="btn btn-primary btn--large"
           :href="link.url"
           target="_blank"
        >
          {{ KriensTourismus.languageKeys['to-website'] }}
        </a>
      </div>
    </modal>
  </div>
</template>

<script>
import Card from './Card.vue'

export default {
  name: 'ModalCard',
  props: ['image', 'title', 'text','meta', 'link'],
  components: {
    Card
  },
  methods: {
    showModal () {
      this.$modal.show('sight-modal-' + this.title);
    }
  }
}
</script>